import type { IControl } from '@eureka/utils/control';
import { controlDeferred } from '@eureka/utils/control';
import { type IPackageType, type RechargeEligibilityInfo } from '@eureka/services/src/apis/common.api.types';
import { packageInfoDeferred } from '@eureka/utils/package-info';
import { computed, ref } from 'vue';
import { createSharedComposable, tryOnBeforeMount } from '@vueuse/core';
import { accountDeferred, isUserLogin } from '@eureka/utils/account';
import type { Account } from '@patsnap-utils/biz';
import { clientDeferred } from '@eureka/utils/client';
import { rechargeInfoDeferred } from '@eureka/utils/recharge-info';

export const usePlg = createSharedComposable(() => {
    const packageInfo = ref<IPackageType[]>([])
    const control = ref<IControl>()
    const isLogin = ref<boolean>(false)
    const account = ref<Account | null>(null);
    const isFeiShu = ref(false)
    const recharge = ref<RechargeEligibilityInfo | null>(null)

    const isFreemium = computed(() => {
        return control.value?.freemium
    })

    /**
     * 企业用户
     */
    const isEnterpriseTenant = computed(() => {
        return account.value?._info.company_id
    })

    /**
     * 认为是plg用户
     */
    const isPersonalTenant = computed(() => {
        return !isEnterpriseTenant.value
    })

    /**
     * 认为是plg basic
     */
    const isFreeUser = computed(() => {
        return isPersonalTenant.value && isFreemium.value
    })

    /**
     * 认为是plg pro
     */
    const isPro = computed(() => {
        return isPersonalTenant.value && !isFreeUser.value
    })

    const isCreditsAvailable = computed(() => {
        return control.value?.credit_package;
    })

    const isCountPackageAvailable = computed(() => {
        return control.value?.count_package;
    })

    const isEnterpriseCommercialUser = computed(() => {
        return isEnterpriseTenant.value && packageInfo.value.some(item => item.package_type === 'COMMERCIAL')
    })

    const isEnterPriseFreeUser = computed(() => {
        return isEnterpriseTenant.value && packageInfo.value.some(item => item.package_type === 'FREE')
    })

    const hasCreditPackage = computed(() => {
        return control.value?.credit_package
    })

    tryOnBeforeMount(async() => {
        isLogin.value = await isUserLogin();
        if (isLogin.value) {
            packageInfo.value = await packageInfoDeferred.promise;
        }
        const [{ isFeiShu: clientIsFeiShu }, accountInfo, controlInfo, rechargeInfo] = await Promise.all([clientDeferred.promise, accountDeferred.promise, controlDeferred.promise, rechargeInfoDeferred.promise])
        recharge.value = rechargeInfo;
        control.value = controlInfo;
        account.value = accountInfo;
        isFeiShu.value = clientIsFeiShu
    })

    return {
        isEnterpriseTenant,
        isPersonalTenant,
        isFreeUser,
        isPro,
        isFeiShu,
        isCreditsAvailable,
        isCountPackageAvailable,
        isEnterpriseCommercialUser,
        isEnterPriseFreeUser,
        hasCreditPackage,
    }
})
